import { AnyAction } from '@reduxjs/toolkit';
import { IQuestion } from 'types/Question.types';
import { CLOSE_TABLE_MODAL, SET_TABLE_MODAL_DATA } from '../tableModal';
import { COMPANY_CHANGED } from 'store/constants';

export interface ITableModalReducerState {
  isOpen: boolean;
  question: IQuestion | null;
}

const INIT_STATE: ITableModalReducerState = {
  isOpen: true,
  question: null,
};

const tableModalReducer = (state = INIT_STATE, action: AnyAction) => {
  switch (action.type) {
    case CLOSE_TABLE_MODAL:
      return {
        ...state,
        isOpen: false,
        question: null,
      };
    case COMPANY_CHANGED:
      // Holds a question from the configuration that was open.
      return {
        ...INIT_STATE,
      };
    case SET_TABLE_MODAL_DATA:
      return {
        ...state,
        isOpen: true,
        question: action.payload.question,
      };
    default:
      return state;
  }
};

export default tableModalReducer;
